import { RESET_ERRORS, SET_GLOBAL_ERROR } from "../type";

const initState = {
  errorCode: 0,
  modalErrorVisible: false,
  errorTitle: "",
  errorMessage: "",
};

export default function (state = initState, action) {
  const { type, payload } = action;

  switch (type) {
    case RESET_ERRORS:
      return initState;

    case SET_GLOBAL_ERROR:
      return {
        ...state,
        errorCode: payload.errorCode,
        modalErrorVisible: true,
        errorTitle: payload.errorTitle,
        errorMessage: payload.errorMessage,
      };
    default:
      return state;
  }
}
